import AdminLiveSupportDetailPage from '../../../components/admin/support/AdminLiveSupportDetailPage'

export default function SupportTicketDetail() {
  return <AdminLiveSupportDetailPage />
}
